var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    d: "M783,511.4H498V227.9c0-19.4-13.2-35.2-32.6-35.2c-19.4,0-32.6,15.7-32.6,35.2v315.6c0,16.7,9.1,28.2,24.8,31.7c3.1,0.9,6.4,1.4,9.8,1.4H783c19.4,0,35.2-13.2,35.2-32.6C818.2,524.5,802.4,511.4,783,511.4L783,511.4L783,511.4z M500,10c270.6,0,490,219.4,490,490c0,270.6-219.4,490-490,490C229.4,990,10,770.6,10,500C10,229.4,229.4,10,500,10 M500,64.9c-58.8,0-115.7,11.5-169.4,34.2c-51.8,21.9-98.3,53.3-138.3,93.3c-40,40-71.4,86.5-93.3,138.3C76.4,384.3,64.9,441.2,64.9,500c0,58.8,11.5,115.7,34.2,169.3c21.9,51.8,53.3,98.3,93.3,138.3c40,40,86.5,71.4,138.3,93.3c53.6,22.7,110.6,34.2,169.3,34.2c58.8,0,115.7-11.5,169.3-34.2c51.8-21.9,98.3-53.3,138.3-93.3c40-40,71.4-86.5,93.3-138.3c22.7-53.6,34.2-110.6,34.2-169.3c0-58.8-11.5-115.8-34.2-169.3c-21.9-51.8-53.3-98.3-93.3-138.3c-40-40-86.5-71.4-138.3-93.3C615.7,76.4,558.8,64.9,500,64.9L500,64.9L500,64.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.7927e05fe2c3a4a812e491211fceeac8.svg";
export { ForwardRef as ReactComponent };